import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <DevSupport ComponentPreviews={ComponentPreviews}
                    useInitialHook={useInitial}
        >
            <App/>
        </DevSupport>
    </React.StrictMode>
);

// 如果你想让你的应用离线工作并加载更快，你可以将下面的 unregister() 改为 register()
// 注意这会带来一些陷阱，详情见 https://cra.link/PWA
serviceWorkerRegistration.unregister();

// 如果你想开始测量应用的性能，可以传递一个函数
// 来记录结果（例如：reportWebVitals(console.log)）
// 或者发送到分析端点。了解更多：https://bit.ly/CRA-vitals
reportWebVitals();
